<template>
  <div>
    <div class="main-wrapper">
      <!--begin::sidebar-->
      <sidebar-component classMenu="BbmIndex"></sidebar-component>
      <!--end::sidebar-->

      <div class="page-wrapper">
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->

        <!--begin::content-->
        <div class="page-content">
          <div
            class="d-flex justify-content-between align-items-center flex-wrap grid-margin"
          >
            <div>
              <h4 class="mb-12 mb-md-0"></h4>
            </div>

            <div class="col-lg-12 col-xl-12 stretch-card">
              <div class="card">
                <form class="forms-sample" @submit.prevent="submitData" method="POST">

                  <div class="card-header">
                    <h4 style="margin-right: 5px" class="float-start mx-2">
                      Request LeadTime
                    </h4>
                  </div>
                  <div class="card-body">
                    <div class="row my-3">
                      <div class="col-sm-6">
                        <div class="form-group row my-2">
                          <label
                            for="exampleInputUsername2"
                            class="col-sm-3 col-form-label"
                            >Jenis Request</label
                          >
                          <div class="col-sm-9">
                            <input
                              disabled
                              type="text"
                              class="form-control"
                              placeholder="Jenis Request"
                              value="Laporan Leadtime"
                            />
                          </div>
                        </div>
                        <div class="form-group row my-2">
                          <label
                            for="exampleInputUsername2"
                            class="col-sm-3 col-form-label"
                            >Load Id</label
                          >
                          <div class="col-sm-9">
                            <input
                              disabled
                              type="text"
                              class="form-control"
                              placeholder="Load Id"
                              v-model="forms.load_id"
                            />
                          </div>
                        </div>
                        <div class="form-group row my-2">
                          <label
                            for="exampleInputUsername2"
                            class="col-sm-3 col-form-label"
                            >Shipwithreff</label
                          >
                          <div class="col-sm-9">
                            <input
                              disabled
                              type="text"
                              class="form-control"
                              placeholder="Shipwithreff"
                              v-model="forms.shipwith_reff"
                            />
                          </div>
                        </div>
                        <div class="form-group row my-2">
                          <label
                            for="exampleInputUsername2"
                            class="col-sm-3 col-form-label"
                            >Nama Driver</label
                          >
                          <div class="col-sm-9">
                            <input
                              disabled
                              type="text"
                              class="form-control"
                              placeholder="Nama Driver "
                              v-model="forms.driver_name"
                            />
                          </div>
                        </div>
                        <div class="form-group row my-2">
                          <label
                            for="exampleInputUsername2"
                            class="col-sm-3 col-form-label"
                            >NMK Driver</label
                          >
                          <div class="col-sm-9">
                            <input
                              disabled
                              type="text"
                              class="form-control"
                              placeholder="NMK Driver "
                              v-model="forms.driver_nmk"
                            />
                          </div>
                        </div>
                        <div class="form-group row my-2">
                          <label
                            for="exampleInputUsername2"
                            class="col-sm-3 col-form-label"
                            >Nopol</label
                          >
                          <div class="col-sm-9">
                            <input
                              disabled
                              type="text"
                              class="form-control"
                              placeholder="Nopol "
                              v-model="forms.vehicle_no"
                            />
                          </div>
                        </div>
                        <div class="form-group row my-2">
                          <label
                            for="exampleInputUsername2"
                            class="col-sm-3 col-form-label"
                            >Type Truck</label
                          >
                          <div class="col-sm-9">
                            <input
                              disabled
                              type="text"
                              class="form-control"
                              placeholder="Type Truck "
                              v-model="forms.type_truck"
                            />
                          </div>
                        </div>
                        <div class="form-group row my-2">
                          <label
                            for="exampleInputUsername2"
                            class="col-sm-3 col-form-label"
                            >Pick Plan</label
                          >
                          <div class="col-sm-9">
                            <input
                              disabled
                              type="text"
                              class="form-control"
                              placeholder="Pick Plan"
                              v-model="forms.pick_plan"
                            />
                          </div>
                        </div>
                        <div class="form-group row my-2">
                          <label
                            for="exampleInputUsername2"
                            class="col-sm-3 col-form-label"
                            >Pick Name</label
                          >
                          <div class="col-sm-9">
                            <input
                              disabled
                              type="text"
                              class="form-control"
                              placeholder="Pick Name "
                              v-model="forms.pick_name"
                            />
                          </div>
                        </div>
                        <div class="form-group row my-2">
                          <label
                            for="exampleInputUsername2"
                            class="col-sm-3 col-form-label"
                            >Drop Plan</label
                          >
                          <div class="col-sm-9">
                            <input
                              disabled
                              type="text"
                              class="form-control"
                              placeholder="Drop Plan"
                              v-model="forms.drop_plan"
                            />
                          </div>
                        </div>
                        <div class="form-group row my-2">
                          <label
                            for="exampleInputUsername2"
                            class="col-sm-3 col-form-label"
                            >Drop Name</label
                          >
                          <div class="col-sm-9">
                            <input
                              disabled
                              type="text"
                              class="form-control"
                              placeholder="Drop Name"
                              v-model="forms.drop_name"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="form-group row my-2">
                          <label
                            for="exampleInputUsername2"
                            class="col-sm-3 col-form-label"
                            >Waktu Keluar Pick Terakhir</label
                          >
                          <div class="col-sm-9">
                            <input
                              disabled
                              type="text"
                              class="form-control"
                              placeholder="Drop Name"
                              v-model="forms.time_end_pick"
                            />
                          </div>
                        </div>
                        <div class="form-group row my-2">
                          <label
                            for="exampleInputUsername2"
                            class="col-sm-3 col-form-label"
                            >Lokasi Keluar Pick</label
                          >
                          <div class="col-sm-9">
                            <input
                              disabled
                              type="text"
                              class="form-control"
                              placeholder="Drop Name"
                              v-model="forms.location_end_pick"
                            />
                          </div>
                        </div>
                        <div class="form-group row my-2">
                          <label
                            for="exampleInputUsername2"
                            class="col-sm-3 col-form-label"
                            >Waktu Masuk Drop Pertama</label
                          >
                          <div class="col-sm-9">
                            <input
                              disabled
                              type="text"
                              class="form-control"
                              placeholder="Drop Name"
                              v-model="forms.time_drop_frist"
                            />
                          </div>
                        </div>
                        <div class="form-group row my-2">
                          <label
                            for="exampleInputUsername2"
                            class="col-sm-3 col-form-label"
                            >Lokasi Masuk Drop</label
                          >
                          <div class="col-sm-9">
                            <input
                              disabled
                              type="text"
                              class="form-control"
                              placeholder="Drop Name"
                              v-model="forms.time_drop_end"
                            />
                          </div>
                        </div>
                        <div class="form-group row my-2">
                          <label
                            for="exampleInputUsername2"
                            class="col-sm-3 col-form-label"
                            >Keterangan Driver</label
                          >
                          <div class="col-sm-9">
                            <textarea
                              class="form-control"
                              placeholder="Keterangan Driver"
                              v-model="forms.remarks"
                              disabled
                            ></textarea>
                          </div>
                        </div>
                        <div class="form-group row my-2">
                          <label
                            for="exampleInputUsername2"
                            class="col-sm-3 col-form-label"
                            >Keputusan</label
                          >
                          <div class="col-sm-9">
                            <div class="form-check my-2">
                              <label class="form-check-label">
                                <input
                                  type="radio"
                                  class="form-check-input"
                                  name="optionsRadios"
                                  id="optionsRadios"
                                  v-model="forms.respon_sanggahan"
                                  value="approve" />
                                Approve
                                <i class="input-frame"></i
                              ></label>
                            </div>
                            <div class="form-check my-2">
                              <label class="form-check-label">
                                <input
                                  type="radio"
                                  class="form-check-input"
                                  name="optionsRadios"
                                  id="optionsRadios"
                                  v-model="forms.respon_sanggahan"
                                  value="reject" />
                                Reject
                                <i class="input-frame"></i
                              ></label>
                            </div>
                          </div>
                        </div>
                        <div class="form-group row my-2">
                          <label
                            for="exampleInputUsername2"
                            class="col-sm-3 col-form-label"
                            >Alasan</label
                          >
                          <div class="col-sm-9">
                            <textarea
                              class="form-control"
                              placeholder="Keterangan Driver"
                              v-model="forms.respon_remarks"
                            ></textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card-footer">
                    <button class="
                        btn btn-warning
                        text-black
                        fw-bolder
                        btn-icon-text
                      " @click="backForm" type="button">
                      <i class="link-icon" data-feather="arrow-left"></i>
                      {{ $t("backMess") }}
                    </button>
                    &nbsp;&nbsp;&nbsp;
                    <button class="btn btn-primary float-end btn-sm" type="submit">
                      <i class="link-icon" data-feather="save"></i>
                      {{ $t("submitFormTxt") }}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>
<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
// import DirectionsRenderer from "@/middleware/DirectionsRenderer";

export default {
  name: "requestMuatDetail",
  components: {
    "sidebar-component": sidebarComponent,
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
    // DirectionsRenderer

  },
  data() {
    return {
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      isLoading: false,
      errors: [],
      permision_role: [],
      langs: ["id", "en"],
      detailUser: [],
      detailDivisi: [],
      totalRecords: 0,
      forms: [],

      center: {
        lat: -2.548926,
        lng: 118.0148634,
      },
      waypnt: [],
      markers:[],
    };
  },
  watch: {},
  methods: {
    backForm(){
      window.location.href = "/request-leadtime";
    },
    submitData(){
      
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataSend"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          this.loading();
          var formData = {
            respon_sanggahan:this.forms.respon_sanggahan,
            respon_remarks:this.forms.respon_remarks
          }
          const baseURI = this.$settings.endPointLincMobile + "web/m-sanggahan/update/"+this.forms.m_sanggahan_id;
          this.$http
            .post(baseURI, formData)
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                window.location.href = "/request-leadtime";
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            })
            .catch((error) => {
              this.loading();
              if (error.response) {
                if (error.response.status === 422) {
                  this.errors = error.response.data.errors;
                  this.resultError(error.response.data.errors);
                } else if (error.response.status === 500) {
                  this.$router.push("/server-error");
                } else {
                  this.$router.push("/page-not-found");
                }
              }
            });
        }
      });
      // console.log(this.forms);
    },  
    createData() {
      window.location.href = "/master-bbm/add";
    },

    uploadData() {
      window.location.href = "/master-bbm/upload";
    },

    editData(index, row) {
      var params = this.$onRandom(row.rm_fuel_master_id);
      window.location.href = "/master-bbm/edit/" + params;
    },

    detailData(index, row) {
      var params = this.$onRandom(row.rm_fuel_master_id);
      window.location.href = "/master-bbm/detail/" + params;
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
      this.loadItems();
    },

    onColumnFilter(params) {
      params.page = 1;
      this.updateParams(params);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field,
        },
      });
    },

    onPerPageChange(params) {
      this.updateParams({ per_page: params.currentPerPage });
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    //ini function button
    filterSearch() {
      const periodCodeFilterElement = document.querySelector(
        '[name="vgt-period_code"]'
      ); //ini setiap field pasti ada vgt-

      const periodNameFilterElement = document.querySelector(
        '[name="vgt-period_name"]'
      ); //ini setiap field pasti ada vgt-

      var params = {
        columnFilters: {
          period_code: periodCodeFilterElement.value,
          period_name: periodNameFilterElement.value,
          price: "",
          price_gap: "",
          effective_date: "",
          expired_date: "",
        },
        page: 1,
      }; // params yang di kirim

      this.updateParams(params); //ini untuk update params vue good table
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.isLoading = false;
      }, 1000); // hide the message after 3 seconds
    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == "MSanggahanController") {
          rolePermision = permision;
          // console.log(permision);
        }
      });
      if (!rolePermision.method_read) {
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;
    },

    logout() {
      this.$logoutUser();
      this.$router.push("/");
    },
    getTruckLocation(){
      const baseURI = this.$settings.endPointCt + "real-monitoring/get";
      this.isLoading = true;
      return this.$http
        .get(
          baseURI + 
            `?vehicle_no=${this.forms.vehicle_no}`
        )
        .then((response) => {
          this.loading();
          if(response.data.status == 200){
            let data = response.data.datas.data[0];
            this.center = {
              lat:data.latitude,
              lng:data.longitude,
            }
            this.markers.push({
              position:{
                lat:data.latitude,
                lng:data.longitude,
              }
            });
          }
        });
    },
    checkData(){
      let params = this.$onBehind(this.$route.params.id);
      let idDetail = params[0];
      if (localStorage["detailDatas"]!==undefined && localStorage["detailDatas"]!==0 && localStorage["detailDatas"]!==null && localStorage["detailDatas"]!==false && localStorage["detailDatas"]!==''){
        let details = JSON.parse(localStorage.detailDatas);
        
        if(idDetail === details.m_sanggahan_id){
          this.forms = details;
          console.log(this.forms);

          this.forms.pick_plan=this.forms.shipment.length > 0 ? this.forms.shipment[0].pick_plan : '';
          this.forms.pick_name=this.forms.shipment.length > 0 ? this.forms.shipment[0].pick_name : '';
         
          this.forms.drop_plan=this.forms.shipment.length > 0 ? this.forms.shipment[this.forms.shipment.length - 1].dest_plan : '';
          this.forms.drop_name=this.forms.shipment.length > 0 ? this.forms.shipment[this.forms.shipment.length - 1].dest_name : '';
          
          this.forms.time_end_pick=this.forms.shipment.length > 0 ? this.forms.shipment[this.forms.shipment.length - 1].finish_pick : '';
          this.forms.location_end_pick=this.forms.shipment.length > 0 ? this.forms.shipment[this.forms.shipment.length - 1].pick_name : '';
          this.forms.time_drop_frist=this.forms.shipment.length > 0 ? this.forms.shipment[this.forms.shipment.length - 1].start_dest : '';
          this.forms.time_drop_end=this.forms.shipment.length > 0 ? this.forms.shipment[0].dest_name : '';


// Pick Plan : pick_plan (array awal)
// Pick Name : pick_name (array awal)
// Drop Plan : dest_plan (array akhir)
// Drop Name : dest_name (array akhir)
// Waktu Keluar Pick Terakhir : finish_pick (array akhir)  time_end_pick
// Lokasi Keluar Pick :pick_name (array akhir) location_end_pick
// Waktu Masuk Drop Pertama : start_dest (array awal)   time_drop_frist
// Lokasi Masuk Drop: dest_name (array awal) time_drop_end


        }else{
          this.$router.push("/request-leadtime");
        }
      }else{
        this.$router.push("/request-leadtime");
      }

    }
  },
  events: {},
  created: function () {
    this.checkData();
  },
  mounted() {
    this.fetchIt();
    this.loading();

  },
};
</script>
